import Enum from "./Enum";

export default Enum.create( {
	COMMITMENT: "COMMITMENT",
	DECISION: "DECISION",
	TOPIC: "TOPIC",
} );
